import _ from 'lodash'
import store from '@/store'
import * as types from '@/store/types'
import * as utils from '@/mixins/utils'
import SimpleVueValidator from 'simple-vue-validator';
const Validator = SimpleVueValidator.Validator;

const userProfileMixin = {

    validators: {
      'user.firstname': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }
        })
      },
      'user.lastname': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
       'user.position': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },      
      'user.email_address': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
          if (!utils.isEmailValid(value)) {
              return 'Email is invalid.'
          }
        })
      },
      // 'user.phone': function (value) {
      //   return Validator.custom(function () {
      //     if (Validator.isEmpty(value)) {
      //         return 'This is a required field.'
      //     }
      //   })
      // },
      // 'user.username': function (value) {
      //   return Validator.custom(function () {
      //     if (Validator.isEmpty(value)) {
      //         return 'This is a required field.'
      //     }  
      //   })
      // },
      'user.credential': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'confirm_credential': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'confirm_credential, user.credential': function (confirmCredential, credential) {
        return Validator.custom(function () {

          if (credential !== confirmCredential) {
              return 'Password does not match the confirm password.'
          }  
        })
      },
      'user.active': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      }

    }
  }

export default userProfileMixin


// WEBPACK FOOTER //
// ./src/mixins/validators/UserProfile-validators.js